import { render } from "./OfferDetailsPage.vue?vue&type=template&id=bd69555e"
import script from "./OfferDetailsPage.vue?vue&type=script&lang=js"
export * from "./OfferDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__